import React from "react";
import TailormedLogoIcon from "../assets/svg/MainLogoIcon";
import { Layout as AntLayout } from "antd";
import styled from "styled-components";
import { RED_GRAD } from "../constant/colors";

const { Header: AntHeader } = AntLayout;

const Header = styled(AntHeader)`
  background-color: ${RED_GRAD};
  height: 64px;
  max-height: 64px;
  position: sticky;
  top: 0;
  z-index: 10;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  height: 64px;
`;

const TailormedLogoContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0px;
`;

const TailormedVisualIcon = null;
const TailormedHeaderText = null;

const AppLayout = ({ children }) => {
  return <Header>{children}</Header>;
};

const ErrorPageLayout = ({ children }) => <div>{children}</div>;

export {
  ErrorPageLayout,
  AppLayout,
  TailormedLogoIcon,
  LogoContainer,
  TailormedVisualIcon,
  TailormedHeaderText,
  TailormedLogoContainer
};
